import {Button, CardMedia, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {Loading} from 'presentation/components/Loading/Loading';
import {translations} from 'presentation/translations-new';

import {PerksTaggingEnum} from 'main/analytics/gaTagsEnum';
import {makeGetWhoIndicatesLink} from 'main/factories/usecases/private/remote-home/get-who-indicates';
import whoIndicatesImgSm from 'presentation/assets/images/who-indicates-menu.webp';
import {AlertModal} from 'presentation/components/AlertModal';
import {useGetEndpointUrl} from 'presentation/hooks';

const {see, referAndEarn, serverError, unexpectedError, serverErrorTitle, close} =
	translations['pt-br'].commons;
const {recommendation} = translations['pt-br'].privateFlow.services;
const {whoIndicatesDescription} = translations['pt-br'].others.profileMenu;

export function WhoIndicates() {
	const {isError, setIsError, getLink, isLoading} = useGetEndpointUrl(recommendation);
	const theme = useTheme();
	const handleClick = () => {
		getLink(makeGetWhoIndicatesLink);
	};

	return (
		<Stack
			flexDirection="row"
			alignItems="center"
			height="77px"
			bgcolor={theme.palette.background.paper}
			borderRadius={1.5}>
			<CardMedia
				component="img"
				image={whoIndicatesImgSm}
				title={referAndEarn}
				sx={{
					width: 'auto',
					borderRadius: '12px 0 0 12px',
				}}
			/>
			<Stack flexDirection="row" alignItems="center" p={1.5} gap={1}>
				<Stack>
					<Typography variant="caption" fontWeight={600}>
						{referAndEarn}
					</Typography>
					<Typography variant="caption" lineHeight={1.43}>
						{whoIndicatesDescription}
					</Typography>
				</Stack>

				{isLoading ? (
					<Loading size={12} color="inherit" fullWidth={false} />
				) : (
					<Button
						sx={{lineHeight: 'normal', p: 0, minWidth: 'unset'}}
						data-tag-id={PerksTaggingEnum.CLICK_QUEM_INDICA_BENEFICIOS}
						disabled={isLoading}
						onClick={handleClick}
						size="medium"
						variant="text">
						{see}
					</Button>
				)}
			</Stack>

			{isError ? (
				<AlertModal
					open={isError}
					onClose={() => setIsError(false)}
					description={serverError}
					title={serverErrorTitle}
					headerTitle={unexpectedError}
					buttonLabel={close}
					variant="info"
				/>
			) : null}
		</Stack>
	);
}
